import {
    validateStreet,
    validateAptSuite,
    validateCity,
    validateState,
    validateZip,
    DEFAULT_STATE
  } from './validations';

export const ENTER_STREET = 'ENTER_STREET';
export const ENTER_APTSUITE = 'ENTER_APTSUITE';
export const ENTER_CITY = 'ENTER_CITY';
export const SELECT_STATE = 'SELECT_STATE';
export const ENTER_ZIP = 'ENTER_ZIP';

export const enterStreetAddress = (value) => {
  const errMsg = validateStreet(value);
  if (errMsg) {
    return {
      type: ENTER_STREET,
      errMsg
    };
  }
  return {
    type: ENTER_STREET,
      value
    };
};

export const enterAptSuite = (value) => {
  const errMsg = validateAptSuite(value);
  if (errMsg) {
    return {
      type: ENTER_APTSUITE,
      errMsg,
      value: !value ? '' : value
    };
  }
  return {
    type: ENTER_APTSUITE,
    value
  };
};

export const enterCity = (value) => {
  const errMsg = validateCity(value);
  if (errMsg) {
    return {
      type: ENTER_CITY,
      errMsg,
      value: !value ? '' : value
    };
  }
  return {
    type: ENTER_CITY,
    value
  };
};

export const selectState = (value, defaultValue = DEFAULT_STATE) => {
  const errMsg = validateState(value, defaultValue);
  if (errMsg) {
    return {
      type: SELECT_STATE,
      errMsg,
      value: DEFAULT_STATE
    };
  }
  return {
    type: SELECT_STATE,
    value
  };
};

export const enterZip = (value, maxLength) => {
  const errMsg = validateZip(value, maxLength);
  if (errMsg) {
    return {
      type: ENTER_ZIP,
      errMsg,
      value: !value ? '' : value
    };
  }
  return {
    type: ENTER_ZIP,
    value
  };
};

